export const RESPONSE_CODE_COLOR_PALETTE = {
  '1xx': ['#234b14', '#5d7616', '#96b148'],
  '2xx': ['#55c143', '#2e971d', '#c3f33e'],
  '3xx': ['#2f5bb0', '#293e6a', '#9aafd7'],
  '4xx': ['#ff7a00', '#f4a300', '#ffc7a0'],
  '5xx': ['#f21c0f', '#a51610', '#e8767a'],
};

export const TARGET_OPTIONS = [
  {
    key: 'arguments',
    translationKey: 'dynamicRule.configPage.targetValue.argument',
  },
  {
    key: 'asn',
    translationKey: 'dynamicRule.configPage.targetValue.asn',
  },
  {
    key: 'cookies',
    translationKey: 'dynamicRule.configPage.targetValue.cookie',
  },
  {
    key: 'country',
    translationKey: 'dynamicRule.configPage.targetValue.country',
  },
  {
    key: 'headers',
    translationKey: 'dynamicRule.configPage.targetValue.header',
  },
  {
    key: 'ip',
    translationKey: 'dynamicRule.configPage.targetValue.ip',
  },
  {
    key: 'organization',
    translationKey: 'dynamicRule.configPage.targetValue.organization',
  },
];

export const MAX_QUARANTINE_TIME_HOURS = 87658; // ~10 years
export const MAX_QUARANTINE_TIME_HOURS_OFFLOAD_IP = 21; // ddosblockmaster limit

export const AI_TOOL_DISPLAY_NAMES: Record<string, string> = {
  'ai-chatgpt': 'ChatGPT',
  'ai-claude': 'Claude',
  'ai-perplexity': 'Perplexity',
  'ai-gemini': 'Gemini',
  'ai-bing': 'Bing AI',
  'ai-copilot': 'Copilot',
  'gen-ai-tool': 'Gen AI Tool',
};

export function getAiToolDisplayName(tagName: string): string {
  return (
    AI_TOOL_DISPLAY_NAMES[tagName] ||
    tagName.replace(/^ai-/, '').replace(/\b\w/g, (l) => l.toUpperCase())
  );
}
